import axios from "axios";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class CarRentalPackageService {

  static getcarrentalPackageList(item) {

    let api = `${API_BASE_URL}${API_PATHS.getcarrentalpackage}`;
    const params = new URLSearchParams();
    
  
    if (item?.id) {
      params.append("id", item.id);
    }  if (item?.slug) {
      params.append("slug", item.slug);
    }
     

    if (item?.limit) {
      params.append("limit", item.limit);
    }
    if (item?.page) {
      params.append("page", item.page);
    }

    if (item?.duration) {
      params.append("duration", item.duration);
    }
    if (item?.priceRange) {
      params.append("minPrice", item.priceRange[0]);
      params.append("maxPrice", item.priceRange[1]);
    }

    api = `${api}?${params.toString()}`;
    
    console.log( api);
    console.log(item?.slug);
    // Make the API request
    return axios
      .get(api)
      .then((response) => {
        if (response.data) {
          // Process response data if needed
        }
        return response.data;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  }
  
  static carpackageprice(item) {
  
    let api = '';
    
    
   api = `${API_BASE_URL}${API_PATHS.carrentalprice}`;
   
     return axios
      .post(api,item)
      .then((response) => {
        if (response.data) {
        }
        return response.data;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  }
    
    
  static getairportPrice(item) {

    let api = `${API_BASE_URL}${API_PATHS.getAirportCarPrice}`;
    const params = new URLSearchParams();
    
  
    if (item?.id) {
      params.append("id", item.id);
    }  
     

    if (item?.limit) {
      params.append("limit", item.limit);
    }
    if (item?.page) {
      params.append("page", item.page);
    }

    if (item?.placeId) {
      params.append("place", item.placeId);
    }

    if (item?.carType) {
      params.append("carType", item.carType);
    }
   
    

    api = `${api}?${params.toString()}`;

    // Make the API request
    return axios
      .get(api)
      .then((response) => {
        if (response.data) {
          // Process response data if needed
        }
        return response.data;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  } 

      
  static gethourlyPrice(item) {

    let api = `${API_BASE_URL}${API_PATHS.getHourlyCarPrice}`;
    const params = new URLSearchParams();
    
  
    if (item?.id) {
      params.append("id", item.id);
    }  
     

    if (item?.limit) {
      params.append("limit", item.limit);
    }
    if (item?.page) {
      params.append("page", item.page);
    }

    if (item?.duration) {
      params.append("duration", item.duration);
    }
    if (item?.carType) {
      params.append("carType", item.carType);
    }

    api = `${api}?${params.toString()}`;

    // Make the API request
    return axios
      .get(api)
      .then((response) => {
        if (response.data) {
          // Process response data if needed
        }
        return response.data;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  } 
  
  static getplacewiseHotel(item) {
    let api = `${API_BASE_URL}${API_PATHS.getplacewisehotel}`;
    const params = new URLSearchParams();

    // Ensure the place parameter is added
    if (item.place) {
        params.append("place", item.place);
    } 
    // Construct final API URL
    const finalApiUrl = `${api}?${params.toString()}`;
  
    return axios
      .get(finalApiUrl)
      .then((response) => {
      
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching hotels:", error);
        throw error;
      });
}

      
static getpickupdropPrice(item) {

  let api = `${API_BASE_URL}${API_PATHS.getpickupdropprice}`;
  const params = new URLSearchParams();
  

  if (item?.id) {
    params.append("id", item.id);
  }  
   

  if (item?.limit) {
    params.append("limit", item.limit);
  }
  if (item?.page) {
    params.append("page", item.page);
  }

  if (item?.fromPlaceId) {
    params.append("fromPlace", item.fromPlaceId);
  }
  if (item?.toPlaceId) {
    params.append("toPlace", item.toPlaceId);
  }

  api = `${api}?${params.toString()}`;

  // Make the API request
  return axios
    .get(api)
    .then((response) => {
      if (response.data) {
        // Process response data if needed
      }
      return response.data;
    })
    .catch((error) => {
      console.error("Error:", error);
      throw error;
    });
} 

  
}

export default CarRentalPackageService;